'use client';
import * as React from 'react';
import theme from '@clad-ui/theme';
import { CircleCheckFilled, InfoFilled, WarningFilled, Close } from '../../icons';
import { typeIconClass, StyledAnnouncer, lineLimitClass, ExpandButton, ActionButton, CloseButton, ChildrenWrapper, SkeletonWrapper, Skeleton, } from './Announcer.styles';
import { cleanHtml, cx } from '../../utils';
const Announcer = ({ open = false, onClose, onButtonClick, title = '', children, type = 'info', btnLabel, compact = false, dangerousHtml, icon, isLoading = false, }) => {
    const { useState, useEffect, useRef } = React;
    const ref = useRef(null);
    const withButton = typeof btnLabel === 'string' && !!btnLabel.trim();
    // check if description on mobile is more than 4 lines and needs limitation
    const [limit, setLimit] = useState(!withButton);
    useEffect(() => {
        const announcerChildren = ref === null || ref === void 0 ? void 0 : ref.current;
        // height of 4 lines on mobile is 64px
        if (announcerChildren && announcerChildren.scrollHeight <= 64) {
            setLimit(false);
        }
    });
    const withTitle = typeof title !== 'string' || title.trim();
    const iconClass = cx(typeIconClass, type);
    const announcerIcon = (type === 'info' && <InfoFilled className={iconClass}/>) ||
        (type === 'neutral' && <InfoFilled className={iconClass}/>) ||
        // (type === 'time' && <BellFilled className={iconClass} />) ||
        // (type === 'gift' && <GiftFilled className={iconClass} />) ||
        (type === 'warning' && <WarningFilled className={iconClass}/>) ||
        (type === 'success' && <CircleCheckFilled className={iconClass}/>) ||
        (type === 'error' && <WarningFilled className={iconClass}/>);
    //    || (type === 'neutral' && <Info className={iconClass} />
    let announcerHtml;
    if (typeof dangerousHtml === 'string' && dangerousHtml.trim()) {
        announcerHtml = {
            __html: cleanHtml(dangerousHtml),
        };
    }
    if (!open) {
        return null;
    }
    const iconWithClassName = icon ? React.cloneElement(icon, { className: iconClass }) : null;
    if (!isLoading) {
        return (<StyledAnnouncer className={cx(type, compact && 'compact', !withButton && 'no-button')} data-clad="Announcer">
        {iconWithClassName ? iconWithClassName : announcerIcon}
        {!compact && !!withTitle && <h6>{title}</h6>}
        <ChildrenWrapper className={limit ? lineLimitClass : ''} ref={ref} dangerouslySetInnerHTML={announcerHtml}>
          {!announcerHtml ? children : null}
        </ChildrenWrapper>
        {!!limit && (<ExpandButton onClick={() => {
                    setLimit(false);
                }}>
            Xem thêm
          </ExpandButton>)}
        {typeof onClose === 'function' && (<CloseButton type="button" onClick={onClose}>
            <Close width={theme.sizes.xs} height={theme.sizes.xs}/>
          </CloseButton>)}
        {!compact && !!withButton && (<ActionButton type="button" className={type} onClick={onButtonClick}>
            {btnLabel}
          </ActionButton>)}
      </StyledAnnouncer>);
    }
    return (<SkeletonWrapper>
      <Skeleton width="20px" height="20px" radius="100%"/>
      <div style={{ width: '70%' }}>
        <Skeleton width="100%" height="20px" margin="0 0 4px 0"/>
        <Skeleton width="70%" height="20px"/>
      </div>
      <div style={{ width: '25%', display: 'flex', alignItems: 'flex-end' }}>
        <Skeleton width="100%" height="20px"/>
      </div>
    </SkeletonWrapper>);
};
export default Announcer;
